var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.788,
    height: 589.942,
    viewBox: "0 0 799.788 589.942",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-580.75 -195.521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(580.75 279.264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.223,123.869a77.328,77.328,0,1,1,76.183,98.7l-13.647,5.74L409.1,300.12l-99.737,18.791L268.827,214.577s58.838,1.1,73.859-19.181a77.244,77.244,0,0,1-15.463-71.527Z",
    transform: "translate(-141.224 -38.612)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.993,599.608,152.76,660.8,2,638.538l158.836-46.717Z",
    transform: "translate(237.422 -154.604)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.511,548.335,121.981,474.2,108.625,507.81l141.4,81.348c3.489,11.089,12.177,21.441,24.633,27.692,21.795,10.936,46.8,5.18,55.851-12.857s-1.28-41.525-23.075-52.461c-12.456-6.25-25.949-7.028-36.924-3.2Z",
    transform: "translate(128.607 -128.563)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.068,254.27s14.493,75.164,65.1,73.607S496.437,290.5,496.437,290.5l47.8,26.862s20.715,29.2,20.715,65.792l14.794,70.853,21.022,21.8-62.289,49.052-31.923-45.159-31.923,96.548L243,586.061l4.282-199.009s12.458-95.769,65.4-115.234,77.382-17.547,77.382-17.547Z",
    transform: "translate(-243 -79.862)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.9,84.394s30.355,27.464,61.433,23.128,36.859-15.177,36.859-19.514c0,0,0,1.445-8.673,4.336l-3.614-31.078s-4.336,8.151-20.237,10.942c0,0,13.732-5.737,0-17.012,0,0-7.227,6.071-13.732,6.071,0,0-36.137-49.146-107.688-18.068V30.285l-6.5,16.527-8.392-.73-8.23-.716S227.055,66.326,228.5,80.781s-25.972,87.057,21.344,109.3c0,0-11.226-64.488,8.288-49.311s31.8-8.673,31.8-8.673l33.969-47.7Z",
    transform: "translate(-47.994 -30.285)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.648,589.484,250.68,586.028l-8.028,57.045L415.6,635.147c7.9,8.53,20.181,14.169,34.113,14.489,24.378.559,44.516-15.342,44.979-35.518s-18.924-36.984-43.3-37.543c-13.933-.32-26.46,4.751-34.742,12.909Z",
    transform: "translate(-136.659 -151.226)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.737,430.822s5.45,34.259-10.9,45.938c0,0,5.45,42.045-7.786,55.281,0,0,24.324.985,19.559,13.729,0,0,35.723-5.943,31.051,8.851,0,0-33.059,39.677-25.094,65.387l-108.048-5.434L513.459,552.36",
    transform: "translate(-511.892 -118.96)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 164.394,
    height: 125.592,
    rx: 8,
    transform: "translate(1216.144 296.843)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.056,
    height: 113.111,
    transform: "translate(1224.313 303.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.483,304.991h.059a39.474,39.474,0,0,0,.883-78.785.9.9,0,0,0-.681.236.891.891,0,0,0-.291.652l-.863,76.986a.9.9,0,0,0,.894.912Z",
    transform: "translate(607.458 81.992)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.344,237.433a1.163,1.163,0,0,1,.816.348l26.5,27.1a1.15,1.15,0,0,1,.33.822l-.413,36.838a1.145,1.145,0,0,1-.374.839,1.163,1.163,0,0,1-.874.3,39.733,39.733,0,0,1-26.87-65.862,1.164,1.164,0,0,1,.84-.393Z",
    transform: "translate(602.638 83.496)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.752,225.927a1.167,1.167,0,0,1,.793.324,1.146,1.146,0,0,1,.356.848l-.373,33.238a1.157,1.157,0,0,1-1.985.8l-23.127-23.652a1.16,1.16,0,0,1,.062-1.68,39.816,39.816,0,0,1,24.2-9.873Z",
    transform: "translate(604.18 81.956)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.007,310.621a7.09,7.09,0,1,1-7.01-7.169,7.09,7.09,0,0,1,7.01,7.169Z",
    transform: "translate(604.012 92.328)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.872,310.822a7.09,7.09,0,1,1-7.01-7.169A7.09,7.09,0,0,1,698.872,310.822Z",
    transform: "translate(606.402 92.355)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.738,311.022a7.09,7.09,0,1,1-7.01-7.169A7.09,7.09,0,0,1,716.738,311.022Z",
    transform: "translate(608.792 92.382)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 139.559,
    height: 106.619,
    rx: 8,
    transform: "translate(1008.178 195.521)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 125.69,
    height: 96.024,
    transform: "translate(1015.113 200.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.219,
    cy: 5.219,
    rx: 5.219,
    ry: 5.219,
    transform: "translate(1031.22 221.942)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.229,373.016a3.539,3.539,0,0,1,0,7.078H676.342a3.539,3.539,0,0,1,0-7.078h54.887m0-.867H676.342a4.406,4.406,0,1,0,0,8.812h54.887a4.406,4.406,0,1,0,0-8.812Z",
    transform: "translate(389.061 -149.916)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.256,380.961H667.938a4.406,4.406,0,1,1,0-8.812h41.319a4.406,4.406,0,0,1,0,8.812Z",
    transform: "translate(389.376 -149.916)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.219,
    cy: 5.219,
    rx: 5.219,
    ry: 5.219,
    transform: "translate(1031.22 243.613)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.229,395.53a3.539,3.539,0,0,1,0,7.078H676.342a3.539,3.539,0,0,1,0-7.078h54.887m0-.867H676.342a4.406,4.406,0,0,0,0,8.812h54.887a4.406,4.406,0,1,0,0-8.812Z",
    transform: "translate(389.061 -150.76)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.859,403.476H667.938a4.406,4.406,0,1,1,0-8.812h56.921a4.406,4.406,0,0,1,0,8.812Z",
    transform: "translate(389.376 -150.76)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.219,
    cy: 5.219,
    rx: 5.219,
    ry: 5.219,
    transform: "translate(1031.22 265.283)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.229,418.045a3.539,3.539,0,0,1,0,7.078H676.342a3.539,3.539,0,1,1,0-7.078h54.887m0-.867H676.342a4.406,4.406,0,1,0,0,8.812h54.887a4.406,4.406,0,1,0,0-8.812Z",
    transform: "translate(389.061 -151.604)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.053,425.991H667.938a4.406,4.406,0,1,1,0-8.812h23.115a4.406,4.406,0,1,1,0,8.812Z",
    transform: "translate(389.376 -151.604)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1087.726 463.735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256.836,
    height: 155.887,
    rx: 8,
    transform: "translate(0 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 246.626,
    height: 146.224,
    transform: "translate(5.105 4.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.482,358.025H248.7a.563.563,0,0,1-.563-.563V271.291a.563.563,0,1,1,1.125,0V356.9H428.482a.563.563,0,1,1,0,1.125Z",
    transform: "translate(-207.337 -235.153)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.277,381.273H281.925a1.672,1.672,0,0,1-1.67-1.67V357.061a1.672,1.672,0,0,1,1.67-1.67h16.352a1.672,1.672,0,0,1,1.67,1.67V379.6A1.672,1.672,0,0,1,298.277,381.273Z",
    transform: "translate(-218.506 -264.59)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.993,369.876H327.64a1.672,1.672,0,0,1-1.67-1.67V324.284a1.672,1.672,0,0,1,1.67-1.67h16.352a1.672,1.672,0,0,1,1.67,1.67v43.922A1.672,1.672,0,0,1,343.993,369.876Z",
    transform: "translate(-234.401 -253.193)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.708,381.273H373.356a1.672,1.672,0,0,1-1.67-1.67V357.061a1.672,1.672,0,0,1,1.67-1.67h16.352a1.672,1.672,0,0,1,1.67,1.67V379.6A1.672,1.672,0,0,1,389.708,381.273Z",
    transform: "translate(-250.296 -264.59)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.424,365.378H419.072a1.636,1.636,0,0,1-1.67-1.594V311.27a1.636,1.636,0,0,1,1.67-1.594h16.352a1.636,1.636,0,0,1,1.67,1.594v52.513A1.636,1.636,0,0,1,435.424,365.378Z",
    transform: "translate(-266.192 -248.695)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.14,357.28H464.787a1.672,1.672,0,0,1-1.67-1.67V288.057a1.672,1.672,0,0,1,1.67-1.67H481.14a1.672,1.672,0,0,1,1.67,1.67V355.61A1.672,1.672,0,0,1,481.14,357.28Z",
    transform: "translate(-282.087 -240.597)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.376,
    cy: 3.376,
    r: 3.376,
    transform: "translate(68.219 77.297)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.376,
    cy: 3.376,
    r: 3.376,
    transform: "translate(98.039 55.354)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.376,
    cy: 3.376,
    r: 3.376,
    transform: "translate(127.86 77.297)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.376,
    cy: 3.376,
    r: 3.376,
    transform: "translate(157.68 44.664)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.376,
    cy: 3.376,
    r: 3.376,
    transform: "translate(187.501 32.285)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.155,182.263l-29.891-22.389L166.78,181.958l-.674-.9,30.158-22.589,29.749,22.283L255.575,148.4l.118-.048,29.821-12.015.421,1.044-29.7,11.967Z",
    transform: "translate(-94.848 -100.834)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.4116a2515a522fe12e111a7517982d13.svg";
export { ForwardRef as ReactComponent };